import { QuestionPreview, QuestionType } from '$synapse/models';
import { ChoicePreviewDTO } from './choice-preview-dto';

export interface QuestionPreviewDTO {
  questionUUID: string;
  titre: string;
  questionType: string;
  lesson?: string;
  choices: ChoicePreviewDTO[];
}

export function mapToQuestionPreview(dto: QuestionPreviewDTO): QuestionPreview {
  return new QuestionPreview({
    questionUUID: dto.questionUUID,
    titre: dto.titre,
    questionType: dto.questionType as QuestionType,
    lesson: dto.lesson,
    choices: dto.choices,
  });
}
